import React, { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { LoadingDialog } from '../../../../../../_metronic/_partials/controls';

export function BoxesLoadingDialog() {
  // Orders Redux state
  const { isLoading } = useSelector(
    (state) => ({ isLoading: state.boxes ? state.boxes.listLoading : false }),
    shallowEqual
  );
  // looking for loading/dispatch
  useEffect(() => {}, [isLoading]);
  return <LoadingDialog isLoading={isLoading} text='Уншиж байна ...' />;
}
